import { render } from "./PayHref.vue?vue&type=template&id=52f399ea"
import script from "./PayHref.vue?vue&type=script&lang=js"
export * from "./PayHref.vue?vue&type=script&lang=js"

import "./PayHref.vue?vue&type=style&index=0&id=52f399ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__